export const initialState = {
  isOpen: false,
  chatId: null,
  messages: [],
  isLoading: false,
  messageCount: 0,
  isStreaming: false,
  toolActivity: null,
  showGreeting: true,
  lastSearchTs: 0,
  lastMessageId: null,
  hasReceivedStreamData: false,
  inputDisabled: false,
  suggestions: null
}

export function chatReducer(state, action) {
  switch (action.type) {
    case 'RESTORE_SESSION':
      return {
        ...state,
        chatId: action.chatId,
        isOpen: action.wasOpen,
        messageCount: action.messageCount || 0,
        lastSearchTs: action.lastSearchTs || 0,
        showGreeting: false
      }

    // Back to how a fresh visit starts, but with the panel still open so the
    // guest sees the greeting rather than being dropped back to the page.
    case 'RESET_CONVERSATION':
      return { ...initialState, isOpen: true, showGreeting: true }

    case 'OPEN':
      return { ...state, isOpen: true }

    case 'CLOSE':
      return { ...state, isOpen: false }

    case 'TOGGLE':
      return { ...state, isOpen: !state.isOpen }

    case 'SET_CHAT_ID':
      return { ...state, chatId: action.chatId }

    case 'SET_MESSAGES':
      return {
        ...state,
        messages: action.messages,
        showGreeting: action.messages.length === 0,
        lastMessageId: action.lastMessageId || state.lastMessageId
      }

    case 'ADD_MESSAGE':
      return {
        ...state,
        messages: [...state.messages, action.message],
        showGreeting: action.message.role === 'user' ? false : state.showGreeting,
        lastMessageId: action.message.id || state.lastMessageId
      }

    case 'START_LOADING':
      return {
        ...state,
        isLoading: true,
        isStreaming: false,
        hasReceivedStreamData: false,
        suggestions: null
      }

    case 'STREAMING_STARTED':
      return {
        ...state,
        isStreaming: true,
        hasReceivedStreamData: true,
        toolActivity: null
      }

    case 'STREAM_DONE': {
      const newMessages = [...state.messages]
      // The fallback poll and the ActionCable "done" event can both deliver
      // the same finished message; only append it once.
      const isDuplicate = action.messageId != null &&
        String(action.messageId) === String(state.lastMessageId)
      if (action.content && !isDuplicate) {
        newMessages.push({
          role: 'assistant',
          content: action.content,
          id: action.messageId,
          metadata: action.properties ? { property_cards: action.properties } : undefined
        })
      }
      return {
        ...state,
        messages: newMessages,
        isStreaming: false,
        isLoading: false,
        toolActivity: null,
        suggestions: action.suggestions || null,
        lastMessageId: action.messageId || state.lastMessageId
      }
    }

    case 'SHOW_TOOL_ACTIVITY':
      return {
        ...state,
        toolActivity: { label: action.label, shownAt: Date.now() },
        hasReceivedStreamData: true
      }

    case 'HIDE_TOOL_ACTIVITY':
      return { ...state, toolActivity: null }

    case 'STREAM_ERROR':
      return {
        ...state,
        isStreaming: false,
        isLoading: false,
        toolActivity: null,
        messages: [...state.messages, { type: 'error', content: action.content }]
      }

    case 'ADD_ERROR':
      return {
        ...state,
        messages: [...state.messages, { type: 'error', content: action.content }]
      }

    case 'INCREMENT_COUNT':
      return { ...state, messageCount: state.messageCount + 1 }

    case 'UPDATE_SEARCH_TS':
      return { ...state, lastSearchTs: action.timestamp }

    case 'DISABLE_INPUT':
      return { ...state, inputDisabled: true }

    case 'STOP_LOADING':
      return { ...state, isLoading: false }

    default:
      return state
  }
}
